import { IroNamRequestStatus } from '@shs-digi-care-monorepo/interfaces';

export const statusList = [
    { description: 'status-stepper.request-submitted', values: [IroNamRequestStatus.SUBMITTED] },
    { description: 'status-stepper.under-review', values: [IroNamRequestStatus.UNDER_REVIEW] },
    {
        description: 'status-stepper.referred-out',
        values: [IroNamRequestStatus.PENDING_CUSTOMER_ACTION, IroNamRequestStatus.REFERRED_OUT]
    },
    { description: 'status-stepper.request-resolved', values: [IroNamRequestStatus.CLOSED] }
];
